export const toTemplateToken = (templateId: string, designPhysicalSpecId: string, templateVersion?: number): string => {
  return templateVersion
    ? `s${templateId}:v${templateVersion}..${designPhysicalSpecId}`
    : `s${templateId}..${designPhysicalSpecId}`;
};
